import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders,HttpParams } from '@angular/common/http';

import { Observable, of, throwError } from 'rxjs';
import { catchError, last, map, tap } from 'rxjs/operators';

export class ChargeType {
  id: string;
  text: string;
  value : string;
}

// URL to web api
const baseApiUrl = '';
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
}

@Injectable({
  providedIn: 'root'
})
export class ChargeTypeService {
  constructor(private http: HttpClient) {}

  getChargeTypeList(): Observable<any> {
    const get_url = baseApiUrl + 'commonList/chargeType';
    return this.http.get<any>(get_url,
      { headers: httpOptions.headers }).pipe(
        map(res => res as ChargeType[]),
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }

  getChargeForCustomerList(): Observable<any> {
    const get_url = 'charge/getChargeForCustomer';
    return this.http.get<any>(get_url,
      { headers: httpOptions.headers }).pipe(
        map(res => res as any),
        catchError((error: any) => {
          return throwError(error);
        })
      );
  }

}
